import { getHighlighter } from 'shiki';

export type Highlighter = Awaited<
  ReturnType<typeof getHighlighter>
> | null;

export const CLIENT_LANGUAGES = [
  'js',
  'jsx',
  'css',
  'text',
  'html',
  'json',
  'md',
] as const;
export const SERVER_LANGUAGES = [
  ...CLIENT_LANGUAGES,
  'ts',
  'tsx',
  'python',
  'php',
  'yaml',
  'mdx',
  'bash',
  'haskell',
  'scss',
] as const;

export type ClientLanguage = (typeof CLIENT_LANGUAGES)[number];
export type ServerLanguage = (typeof SERVER_LANGUAGES)[number];

export interface ContextValues {
  code: string;
  lang: ClientLanguage | '';
}

export type SingleAnnotation = [number] | [number, number];
export type MultipleAnnotations = Array<SingleAnnotation>;
